import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { SplitText } from "gsap/SplitText";

export function fadeUp() {
  gsap.registerPlugin(ScrollTrigger, SplitText);

  // Reset animations delay & stagger inside each block
  const blocks = document.querySelectorAll(".gutenberg-content > .gutenberg-block");

  blocks.forEach((block) => {
    let animationDuration = 0.5;
    let fadeUpDistance = 20;
    let animationDelay = 0;
    let staggerDelay = 0.2;
    const startPosition = "top 80%";
    const ease = "power2.out";

    const fadeUpByLineElements = block.querySelectorAll(".fade-up-by-line");

    fadeUpByLineElements.forEach((element) => {
      fadeUpDistance = element.dataset.distance ? parseFloat(element.dataset.distance) : fadeUpDistance;
      const dataTrigger = element.dataset.trigger;
      const trigger = (dataTrigger ? element.closest(dataTrigger) : null) ||
                      element.closest(".animation-trigger") ||
                      element;

      const split = new SplitText(element, { type: "lines" });

      gsap.from(split.lines, {
        duration: animationDuration,
        y: fadeUpDistance,
        opacity: 0,
        ease: ease,
        stagger: staggerDelay,
        scrollTrigger: {
          trigger: trigger,
          start: startPosition,
          // markers: true,
        }
      });
    });

    const fadeUpElements = block.querySelectorAll(".fade-up");

    fadeUpElements.forEach((element, index) => {
      fadeUpDistance = element.dataset.distance ? parseFloat(element.dataset.distance) : fadeUpDistance;
      animationDuration = element.dataset.duration ? parseFloat(element.dataset.duration) : animationDuration;
      animationDelay = element.dataset.delay ? parseFloat(element.dataset.delay) : animationDelay;
      staggerDelay = 0.08;
      const dataTrigger = element.dataset.trigger;
      const trigger = (dataTrigger ? element.closest(dataTrigger) : null) ||
                      element.closest(".animation-trigger") ||
                      element;

      gsap.from(element, {
        y: fadeUpDistance,
        opacity: 0,
        duration: animationDuration,
        delay: animationDelay + (index * staggerDelay),
        ease: ease,
        scrollTrigger: {
          trigger: trigger,
          start: startPosition,
          // markers: true,
        }
      });
    });

    const fadeInElements = block.querySelectorAll(".fade-in");

    fadeInElements.forEach((element) => {
      animationDuration = element.dataset.duration ? parseFloat(element.dataset.duration) : animationDuration;
      animationDelay = element.dataset.delay ? parseFloat(element.dataset.delay) : animationDelay;
      const dataTrigger = element.dataset.trigger;
      const trigger = (dataTrigger ? element.closest(dataTrigger) : null) ||
                      element.closest(".animation-trigger") ||
                      element;

      gsap.from(element, {
        opacity: 0,
        duration: animationDuration,
        delay: animationDelay,
        ease: ease,
        scrollTrigger: {
          trigger: trigger,
          start: startPosition,
          // markers: true,
        },
      });
    });

    const fadeOutElements = block.querySelectorAll(".fade-out");

    fadeOutElements.forEach((element, index) => {
      animationDuration = element.dataset.duration ? parseFloat(element.dataset.duration) : animationDuration;
      animationDelay = element.dataset.delay ? parseFloat(element.dataset.delay) : animationDelay;
      staggerDelay = 0.08;
      const dataTrigger = element.dataset.trigger;
      const trigger = (dataTrigger ? element.closest(dataTrigger) : null) ||
                      element.closest(".animation-trigger") ||
                      element;

      gsap.to(element, {
        opacity: 0,
        duration: animationDuration,
        delay: animationDelay + (index * staggerDelay),
        ease: ease,
        scrollTrigger: {
          trigger: trigger,
          start: startPosition,
          // markers: true,
        },
      });
    });
  });
}